import initializeComponent from 'Shared/react-initialize';
import { GuideEditPage } from './GuideEditPage';
import { NewGuidePage } from './NewGuidePage';

initializeComponent('GuideEditV2', GuideEditPage);
initializeComponent('GuideNewV2', NewGuidePage);
